export default __webpack_public_path__ + "static/creditline-107x68-cb953193edfc51ef6b74a5479dda728a.webp";